<template>
  <div>
    <el-drawer :title="title" direction="ltr" :visible.sync="addBillVisible" :before-close="addPlanClose" size="47%">
      <el-form :inline="true" label-width="90px" style="margin-top:20px;" size="small" ref="addBillForm"
        class="demo-form-inline" :model="addBillForm" :rules="rules">
        <el-form-item label="一级货主:" prop="primaryCustomerTaxId">
          <el-select clearable v-model="addBillForm.primaryCustomerTaxId" :disabled='disOneCustomer' filterable
            placeholder="请选择" style="width:170px" size="mini" @change="primaryCustomerTaxIdChange">
            <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级货主:" prop="secondaryCustomerTaxId">
          <el-select clearable v-model="addBillForm.secondaryCustomerTaxId" :disabled='dissecondaryCustomerTaxId'
            filterable placeholder="请选择" style="width:170px" size="mini" @change="secondaryCustomerChange">
            <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户单号:" prop="outBillNo">
          <el-input v-model="addBillForm.outBillNo" maxlength="50" placeholder="请输入客户单号" style="width:170px"
            size="mini"></el-input>
        </el-form-item>
        <el-form-item label="提货客户:">
          <el-select clearable v-model="addBillForm.pickupCustomerName" 
            filterable placeholder="请选择" style="width:170px" size="mini" >
            <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
              :value="item.custerName">
            </el-option>
          </el-select>
          <!-- <el-input v-model="addBillForm.pickupCustomerName" :disabled="this.tidanFlag==1" maxlength="30" placeholder="请输入提货客户" style="width:170px" size="mini"></el-input> -->
        </el-form-item>
        <el-form-item prop="remark" label="备注:">
          <el-input type="textarea" v-model="addBillForm.remark" maxlength="100" :rows="1" style="width:200px;"
            size="mini"></el-input>
        </el-form-item>
      </el-form>
      <div style="margin-left:10px;">
        <p>人车信息 <el-button type="primary" @click="addSiji">新增</el-button>
        </p>
        <hr>
        <el-table max-height="300px" border bordersize="mini" size="mini" ref="tabref" :data="subTableData"
          style="width:100%" highlight-current-row :header-cell-style="{background:'#F5F5F5',color:'black'}"
          :header-cell-class-name="Add">
          <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
          <el-table-column label="提货车号" width="140" prop="plateNumber">
            <template slot-scope="scope">
              <div>
                <el-autocomplete class="inline-input" :disabled='scope.row.disPlateNum'
                  v-model.trim="subTableData[scope.$index].plateNumber" size="mini" :fetch-suggestions="querySearch"
                  value-key="plateNumber" @select="handleSelect($event,scope.$index)" popper-class="xiala">
                  <template slot-scope="{ item }">
                    <div class="name">{{ item.plateNumber }},{{ item.driverName }}</div>
                    <span class="addr">{{ item.idNumber? item.idNumber:''}}</span>
                  </template>
                </el-autocomplete>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="driverName" label="司机姓名" width="120">
            <template slot-scope="scope">
              <el-input size="mini" :disabled='scope.row.disDriverName' v-model.trim="scope.row.driverName"
                placeholder="请输入姓名"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="idNumber" label="司机身份证号">
            <template slot-scope="scope">
              <el-input size="mini" :disabled='scope.row.disIdNum' v-model.trim="scope.row.idNumber" placeholder="请输入司机身份证号"
                ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="telephone" label="联系电话">
            <template slot-scope="scope">
              <el-input size="mini" :disabled='scope.row.disTelephone' v-model.trim="scope.row.telephone"
                placeholder="请输入司机联系电话" ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="130">
            <template slot-scope="scope">
              <el-button @click="selectSiji(scope.row,scope.$index)" type="text" size="small">选择司机</el-button>
              <el-button type="text" :disabled='scope.row.disDeleteTable' @click="deleteTable(scope.row,scope.$index)"
                size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin:20px 0 30px 0;" v-if="allDataList.length > 0">
          <p>货物信息</p>
          <hr>
          <div style="display: flex;justify-content: space-between;">
            <div style="display: flex;margin-bottom:10px;">
              <div style="display: flex;">
                <span style="margin-left:10px;">总重量：</span>
                <div>
                  <span style="color:red">{{totalAllWeight}}</span><span> 吨 </span>
                  <span> / </span><span style="color:red">{{totalNumber}}</span><span> 件</span>
                </div>
              </div>
            </div>
          </div>
          <el-table max-height="300px" border bordersize="mini" size="mini" ref="tabref" :data="allDataList" style=""
            highlight-current-row :header-cell-style="{background:'#F5F5F5',color:'black'}">
            <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
            <el-table-column prop="number" align="center" label="操作" width="70">
              <template slot-scope="scope1">
                <el-button @click="tabDelClick(scope1.$index, scope1.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="number" align="center" label="件数" width="100">
              <template slot-scope="scope1">
                <el-input v-model="scope1.row.number" @blur="changeJianShu(scope1.row,scope1.row.number)"
                  v-number-input.float="0" :disabled="scope1.row.disJianShu" maxlength="50" placeholder="输入件数"
                  size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="weight" align="center" label="重量（吨）" width="100">
              <template slot-scope="scope1">
                <el-input v-model="scope1.row.weight" v-number-input.float="4" maxlength="50" placeholder="输入重量"
                  size="mini" :disabled='scope1.row.flag == "理重" || scope1.row.disWeight'
                  @blur="weightInput(scope1.row,scope1.row.weight)"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="" align="center" label="客户可提" width="90">
              <template slot-scope="scope1">
                <span>{{scope1.row.stockAvailableNumber}}件</span>
              </template>
            </el-table-column>
            <el-table-column prop="specification" align="center" label="规格" width="130"></el-table-column>
            <el-table-column prop="steelMillName" align="center" label="产地" width="80"></el-table-column>
            <el-table-column prop="productTypeName" align="center" label="货物类型" width="100"></el-table-column>
            <el-table-column prop="model" align="center" label="材质" width="130"></el-table-column>
            <!-- <el-table-column prop="stockWeight" align="center" label="总重量(吨)"  width="150"></el-table-column> -->
          </el-table>
        </div>
      </div>
      <div class="footerBox">
        <el-button type="primary" @click="addPlanClose">取消</el-button>
        <el-button type="primary" @click="addSubmit()" :loading='addLoading'>保存</el-button>
      </div>
      <el-drawer title="添加货物" :modal-append-to-body="false" size="100%" :visible.sync="addBillVisible" :modal="false"
        :before-close="addPlanClose" class="rightDrawer">
        <div style="margin:22px 0 0 10px;">
          <span style="font-size:15px;margin-left:10px;">规格：</span>
          <el-select v-model="specification" clearable filterable placeholder="请选择" style="width:170px;" size="mini">
            <el-option v-for="(item,index) in specificationData" :key="index" :label="item.specification"
              :value="item.specification"></el-option>
          </el-select>
          <el-button type="primary" size="mini" @click="searchClick" style="margin-left:8px;">查询</el-button>
          <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
        </div>
        <div style="margin:10px 0 0 10px;">
          <el-table size="mini" :data="detailsDataCopyAdd" ref="detailsDataCopyAdd" style="width:100%;"
            :header-cell-style="{background:'#f5f5f5'}" @row-click="dianjixuanzhong" highlight-current-row>
            <el-table-column prop="" align="center" label="客户可提">
              <template slot-scope="scope1">
                <span>{{scope1.row.stockAvailableNumber}}件</span>
              </template>
            </el-table-column>
            <el-table-column prop="specification" align="center" label="规格"></el-table-column>
            <el-table-column prop="steelMillName" align="center" label="产地"></el-table-column>
            <el-table-column prop="productTypeName" align="center" label="货物类型"></el-table-column>
            <el-table-column prop="model" align="center" label="材质" width="150"></el-table-column>
            <el-table-column prop="stockNumber" align="center" label="件数"></el-table-column>
            <el-table-column prop="stockWeight" align="center" label="总重量（吨）" width="120"></el-table-column>
          </el-table>
          <!--分页-->
          <div class="pags" style="text-align: right">
            <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="pageNo"
              :page-size="pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChangeXQ" :total="total"></el-pagination>
          </div>
        </div>
      </el-drawer>
    </el-drawer>
    <select-siji v-if="selectSijiVisible" :table.sync="selectSijiVisible" @selectDriver="selectDriver"></select-siji>
  </div>
</template>

<script>
  import {
    getRelationCustomer, // 字典客户
    JfgetTEmptyBillDriverList, // 取得人车信息
    addEmptyOutstockJanFaForSummary, // 添加出库计划确定
    getDriverList,
    getSpecificationListForSummary,
    getTEmptyStockCustomerList,
    JfaddEmptyBillJanFa, // 出库提单 新增（来源手动）
    JfupEmptyBillJanFa,
    JfdelEmptyBillDetailJanFa,
    JfgetTEmptyBillDetailListForUp,
    JfgetCustomerAvailableNumber
  } from '@/api/wms-stock.js'
  import SelectSiji from '../SelectSiji'
  const vhsrule =
    /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
  const idrule = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/
  const phonerule = /^[1]([3-9])[0-9]{9}$/

  export default {
    components: {
      SelectSiji
    },
    name: 'XinzengTidan',
    data() {
      return {
        subTableData: [],
        detailsDataCopyAdd: [],
        plateNumberOption: [],
        xuanzhongArr: null,
        organizationId: localStorage.getItem('tenantCode'),
        allDataList: [],
        parentData: {},
        addLoading: false,
        paramsObject: {},
        addBillForm: {
          primaryCustomerTaxId: '',
          primaryCustomerName: '',
          secondaryCustomerTaxId: '',
          secondaryCustomerName: '',
          outBillNo: '',
          pickupCustomerName: '',
          carHoldFalg: '',
          remark: '',
          billId: '', // 出库提单id
          outstockId: '' // 出库单id
        },
        customerData: [], // 货主数据
        rules: {
          primaryCustomerTaxId: [{
            required: true,
            message: '请选择一级货主',
            trigger: 'change'
          }],
          secondaryCustomerTaxId: [{
            required: true,
            message: '请选择二级货主',
            trigger: 'change'
          }]
        },
        dissecondaryCustomerTaxId: true,
        TableIndex: 0,
        selectSijiVisible: false,
        carDerList: [],
        specificationData: [],
        specification: '',
        pageNo: 1,
        pageSize: 10,
        total: 0,
        totalNumber: 0,
        totalAllWeight: 0,
        subTableDataB: [],
        billNo: '',
        disOneCustomer: false,
        emptyBillType: ''
      }
    },
    props: {
      title: {
        type: String,
        default: '新增提单'
      },
      tidanFlag: {
        type: Number,
      },
      addBillVisible: {
        type: Boolean,
        default: true
      },
      xiugaiObj: {
        type: Object
      }
    },
    watch: {
      xiugaiObj: {
        deep: true,
        immediate: true,
        handler(val) {
          if (val) {
            this.parentData = val
            // this.organizationId = val.organizationId
          }
        }
      }
    },
    created() {
      var _this = this
      document.onkeydown = function (e) {
        let key = window.event.keyCode
        if (key == 13) {
          _this.addSubmit()
        }
      }
    },
    mounted() {
      this.driverData()
      // this.addSiji()
      this.getRelationCustomer()
      getDriverList().then(res => {
        this.carDerList = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose() {}
        })
      })
      if (this.title == '修改提单') {
        this.disOneCustomer = true
        this.addBillForm.primaryCustomerTaxId = this.parentData.primaryCustomerTaxId
        this.addBillForm.secondaryCustomerTaxId = this.parentData.secondaryCustomerTaxId
        this.addBillForm.outBillNo = this.parentData.outBillNo
        this.addBillForm.pickupCustomerName = this.parentData.pickupCustomerName
        this.addBillForm.remark = this.parentData.remark
        this.addBillForm.billId = this.parentData.billId
        this.billNo = this.parentData.billNo
        this.emptyBillType = this.parentData.emptyBillType
        this.getDriverListData()
        this.getSpecificationListForSummary()
        this.getTStockSummaryList()
        this.getDetailList()
      }
    },
    methods: {
      // 小星星
      Add(obj) {
        if (obj.column.property == 'plateNumber') {
          return 'star'
        }
      },
      addSiji() {
        let obj = {}
        obj.plateNumber = ''
        obj.driverName = ''
        obj.idNumber = ''
        obj.telephone = ''
        obj.delFlag = ''
        obj.disPlateNum = false
        obj.disDriverName = false
        obj.disIdNum = false
        obj.disTelephone = false
        obj.disSelectSiji = false
        obj.disDeleteTable = false
        if (this.subTableData.length >=25) {
          this.$message.error('人车信息不能超过25条')
        } else {
          this.subTableData.push(obj)

        }
      },
      // 获取规格下拉框数据
      getSpecificationListForSummary() {
        getSpecificationListForSummary({
          primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主id  必填）
          customerTaxId: this.addBillForm.secondaryCustomerTaxId // （二级货主id 必填）
        }).then(res => {
          this.specificationData = res
        }).catch(err => {
          this.$message.error(err.message)
        })
      },
      searchClick() {
        this.getTStockSummaryList()
      },
      chongZhi() {
        this.specification = ''
        this.getTStockSummaryList()
      },
      // 获取右边列表
      getTStockSummaryList() {
        getTEmptyStockCustomerList({
          pageNo: this.pageNo, // （必填）
          pageSize: this.pageSize, // （必填）
          primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主id 必填）
          customerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主id 必填）
          specification: this.specification // （规格 非必填）
        }).then(res => {
          this.detailsDataCopyAdd = res.list
          this.total = res.total
        }).catch(err => {
          this.$message.error(err.message)
        })
      },
      handleCurrentChangeXQ(val) {
        this.pageNo = val
        this.getTStockSummaryList()
      },
      handleSizeChangeXQ(val) {
        this.pageSize = val
        this.getTStockSummaryList()
      },
      // 获取一级、二级客户
      getRelationCustomer() {
        getRelationCustomer().then(res => {
          this.customerData = res // 客户
        }).catch(err => {
          this.$message.error(err.message)
        })
      },
      // 一级货主下拉框改变
      primaryCustomerTaxIdChange() {
        this.addBillForm.secondaryCustomerTaxId = ''
        this.dissecondaryCustomerTaxId = false
        this.allDataList.length = 0
        this.totalNumber = 0
        this.totalAllWeight = 0
      },
      // 二级货主下拉框值改变
      secondaryCustomerChange() {
        // 调取右侧添加货物接口
        this.getSpecificationListForSummary()
        this.getTStockSummaryList()
        this.allDataList.length = 0
      },
      selectSiji(row, index) {
        this.TableIndex = index
        this.selectSijiVisible = true
      },
      deleteTable(row, index) {
        this.subTableData.splice(index, 1)
        this.subTableDataB = []
        this.subTableDataB.push(row)
        this.subTableDataB.forEach((item) => {
          row.delFlag = '1'
        })
      },
      selectDriver(row) {
        console.log(row)
        this.$set(this.subTableData[this.TableIndex], 'driverName', row.name)
        this.$set(this.subTableData[this.TableIndex], 'telephone', row.mobile)
        this.$set(this.subTableData[this.TableIndex], 'idNumber', row.identityNo)
      },
      querySearch(str, cb) {
        let arr = []
        this.carDerList.forEach(itme => {
          if (str) {
            if (itme.plateNumber.indexOf(str) != -1) {
              arr.push(itme)
            }
          } else {
            arr.push(itme)
          }
        })
        cb(arr)
      },
      handleSelect(row, index) {
        this.$set(this.subTableData[index], 'driverName', row.driverName)
        this.$set(this.subTableData[index], 'telephone', row.telephone)
        this.$set(this.subTableData[index], 'idNumber', row.idNumber)
      },
      driverData() {
        let obj = {
          plateNumber: '',
          driverName: '',
          idNumber: '',
          telephone: '',
          billDriverId: ''
        }
        this.subTableData.push(obj)
      },
      // 点击
      dianjixuanzhong(row) {
        console.log(row)
        this.xuanzhongArr = {}
        this.xuanzhongArr = row
        if (this.title == '新增提单') {
          this.$set(this.xuanzhongArr, 'number', '')
          this.$set(this.xuanzhongArr, 'weight', '')
          this.$set(this.xuanzhongArr, 'allWeight', '')
          this.$set(this.xuanzhongArr, 'productTypeName', row.productName)
          // this.$set(this.xuanzhongArr, 'billDetailId', row.billDetailId)
          this.allDataList.push(this.xuanzhongArr)
          if (this.allDataList.length != 0) {
            let map = new Map()
            for (let i of this.allDataList) {
              let str = i.stockCustomerId
              if (!map.has(str)) {
                map.set(str, i)
              }
            }
            this.allDataList = [...map.values()]
            this.totalNumber = this.allDataList.reduce((pre, cur) => {
              return pre / 1 + cur.number / 1
            }, 0)
            this.totalAllWeight = this.allDataList.reduce((pre, cur) => {
              return pre / 1 + cur.weight / 1
            }, 0).toFixed(4)
          }
        } else {
          if (this.emptyBillType == '0') {
            this.$set(this.xuanzhongArr, 'number', '')
            this.$set(this.xuanzhongArr, 'weight', '')
            this.$set(this.xuanzhongArr, 'allWeight', '')
            this.$set(this.xuanzhongArr, 'productTypeName', row.productName)
            // this.$set(this.xuanzhongArr, 'billDetailId', row.billDetailId)
            this.allDataList.push(this.xuanzhongArr)
            if (this.allDataList.length != 0) {
              let map = new Map()
              for (let i of this.allDataList) {
                let str = i.stockCustomerId
                if (!map.has(str)) {
                  map.set(str, i)
                }
              }
              this.allDataList = [...map.values()]
              this.totalNumber = this.allDataList.reduce((pre, cur) => {
                return pre / 1 + cur.number / 1
              }, 0)
              this.totalAllWeight = this.allDataList.reduce((pre, cur) => {
                return pre / 1 + cur.weight / 1
              }, 0).toFixed(4)
            }
          } else {
            this.$message.error('装车中不允许添加')
          }
        }

        console.log(this.allDataList, 'this.allDataList')
      },
      tabDelClick(index, row) {
        if (!row.billDetailId) {
          this.allDataList.splice(index, 1)
          this.totalNumber = this.allDataList.reduce((pre, cur) => {
            return pre / 1 + cur.number / 1
          }, 0)
          this.totalAllWeight = this.allDataList.reduce((pre, cur) => {
            return pre / 1 + cur.weight / 1
          }, 0).toFixed(4)
        } else {
          this.$confirm('数据删除之后不能复恢复，是否删除？', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            JfdelEmptyBillDetailJanFa({
              billId: this.addBillForm.billId, // （出库提单id  必填）
              billDetailId: row.billDetailId // （提单子表ID  必填）
            }).then(res => {
              this.$message.success('删除成功')
              this.allDataList.splice(index, 1)
              this.getDetailList()
              this.getTStockSummaryList()
              // this.$parent.getTime()
            }).catch(err => {
              this.$message.error(err.message)
            })
          }).catch(() => {})
        }
      },
      // 添加出库计划取消
      addPlanClose() {
        this.$emit('update:addBillVisible', false)
        this.$parent.xztableData = []
      },
      // 修改出库提单 取得人车信息
      getDriverListData() {
        JfgetTEmptyBillDriverList({
          billId: this.addBillForm.billId
        }).then(res => {
          this.subTableData = res
        }).catch(err => {
          this.$message.error(err.message)
        })
      },
      changeJianShu(row, val) {
        if (val) {
          if (row.number / 1 > row.stockAvailableNumber / 1) {
            this.$message.error('所输入的件数不能大于客户可提件数')
            this.$set(row, 'weight', '')
            this.$set(row, 'allWeight', '')
          } else {
            if (row.flag == '理重') {
              this.$set(row, 'weight', (row.number / 1 * row.singletonWeight).toFixed(4))
              this.$set(row, 'allWeight', (row.number / 1 * row.singletonWeight).toFixed(4))
            } else {
              this.$set(row, 'weight', (row.number / 1 * row.avgWeight).toFixed(4))
              this.$set(row, 'allWeight', (row.number / 1 * row.avgWeight).toFixed(4))
            }
          }
        } else {
          this.$set(row, 'weight', '0.000')
          this.$set(row, 'allWeight', '0.000')
        }
        this.totalNumber = this.allDataList.reduce((pre, cur) => {
          return pre / 1 + cur.number / 1
        }, 0)
        this.totalAllWeight = this.allDataList.reduce((pre, cur) => {
          return pre / 1 + cur.weight / 1
        }, 0).toFixed(4)
      },
      weightInput(row, val) {
        row.weight = Number(val).toFixed(4)
        this.totalNumber = this.allDataList.reduce((pre, cur) => {
          return pre / 1 + cur.number / 1
        }, 0)
        this.totalAllWeight = this.allDataList.reduce((pre, cur) => {
          return pre / 1 + cur.weight / 1
        }, 0).toFixed(4)
      },
      getDetailList() {
        JfgetTEmptyBillDetailListForUp({
          billId: this.addBillForm.billId
        }).then(res => {
          res.forEach((item) => {
            this.$set(item, 'disWeight', true)
            this.$set(item, 'disJianShu', true)
          })
          this.allDataList = JSON.parse(JSON.stringify(res))
          this.totalNumber = this.allDataList.reduce((pre, cur) => {
            return pre / 1 + cur.number / 1
          }, 0)
          this.totalAllWeight = this.allDataList.reduce((pre, cur) => {
            return pre / 1 + cur.weight / 1
          }, 0).toFixed(4)
          console.log(this.allDataList, 'this.allDataList')
          this.allDataList.forEach((item) => {
            JfgetCustomerAvailableNumber({
              primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主id  必填）
              customerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主id 必填）
              productType: item.productType, // （货物类型id  非必填）
              steelMillName: item.steelMillName, // （产地  非必填）
              model: item.model, // （材质 非必填）
              specification: item.specification // （规格  非必填）
            }).then(response => {
              this.$set(item, 'stockAvailableNumber', response)
            }).catch(error => {
              this.$message.error(error.message)
            })
          })
        }).catch(err => {
          this.$message.error(err.message)
        })
      },
      addSubmit() {
        console.log(this.subTableData)
        this.$refs.addBillForm.validate((valid) => {
          if (valid) {
            // let chepai = this.subTableData.some(item => !vhsrule.test(item.plateNumber))
            let idCard = this.subTableData.some(item => !idrule.test(item.idNumber) && item.idNumber != '')
            let phoneCard = this.subTableData.some(item => !phonerule.test(item.telephone) && item.telephone != '')
            let plateNumberflagA = this.subTableData.every(item => item.plateNumber != '')
            if (!plateNumberflagA) {
              this.$message.error('提货车号不能为空')
              this.addLoading = false
              return
            } else if (idCard) {
              this.$message({
                message: '身份证号不正确',
                type: 'error'
              })
              this.addLoading = false
              return
            } else if (phoneCard) {
              this.$message({
                message: '手机号不正确',
                type: 'error'
              })
              this.addLoading = false
              return
            }
            this.addBillForm.primaryCustomerName = this.customerData.filter(item => item.taxpayerNumber == this
              .addBillForm.primaryCustomerTaxId)[0].custerName
            this.addBillForm.secondaryCustomerName = this.customerData.filter(item => item.taxpayerNumber == this
              .addBillForm.secondaryCustomerTaxId)[0].custerName
            console.log(this.addBillForm, this.subTableData)
            let plateNumber = '';
            let driverName = '';
            let telephone = '';
            let idNumber = ''
            plateNumber = this.subTableData.map(item => item.plateNumber).join(',')
            // 司机姓名
            let driverNameArr = this.subTableData.map(item => item.driverName)
            driverNameArr.forEach((item, index) => {
              if (item == '') {
                driverNameArr.splice(index, 1)
              }
            })
            driverName = driverNameArr.join(',')
            // 司机联系电话
            let telephoneArr = this.subTableData.map(item => item.telephone)
            telephoneArr.forEach((item, index) => {
              if (item == '') {
                telephoneArr.splice(index, 1)
              }
            })
            telephone = telephoneArr.join(',')
            // 司机身份证
            let idNumberArr = this.subTableData.map(item => item.idNumber)
            idNumberArr.forEach((item, index) => {
              if (item == '') {
                idNumberArr.splice(index, 1)
              }
            })
            idNumber = idNumberArr.join(',')
            console.log(driverName, telephone, idNumber)
            if (this.subTableData.length == 0) {
              this.$message.error('请添加人车信息再保存')
            } else if (this.subTableData.length > 25) {
              this.$message.error('人车信息不能超过25条')
            } else if (this.allDataList.length == 0) {
              this.$message.error('请添加货物信息再保存')
            } else {
              let flagA = this.allDataList.every(item => item.number / 1 != 0)
              if (!flagA) {
                this.$message.error('件数不能为空或0')
                return
              }
              let flagB = this.allDataList.every(item => item.weight / 1 > 0)
              console.log(flagB, 'flagB')
              if (!flagB) {
                this.$message.error('重量不能为0或者小于0')
                return
              }
              if (flagA && flagB) {
                if (this.title == '新增提单') {
                  this.addLoading = true
                  let tEmptyBillMaster = {
                    primaryCustomerName: this.addBillForm.primaryCustomerName, // 一级货主名称 必填
                    primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // 一级货主id 必填
                    secondaryCustomerName: this.addBillForm.secondaryCustomerName, // （二级货主名称 必填）
                    secondaryCustomerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主id 必填）
                    remark: this.addBillForm.remark, // （出库提单备注 非必填）
                    outBillNo: this.addBillForm.outBillNo, // 客户单号
                    pickupCustomerName: this.addBillForm.pickupCustomerName, // 客户单号
                    plateNumber: plateNumber, // （出库车牌号 =人车信息 提货车号逗号拼接 必填）
                    driverName: driverName, // （司机姓名 =人车信息 司机姓名逗号拼接 非必填）
                    telephone: telephone, // （司机手机 =人车信息 司机电话逗号拼接 非必填）
                    idNumber: idNumber, // （身份证号 =人车信息 司机身份证逗号拼接 非必填）
                    carHoldFalg: 0 // 扣车标记 0：不扣，1：扣车 必填）
                  }
                  JfaddEmptyBillJanFa({
                    tEmptyBillMaster: tEmptyBillMaster,
                    tEmptyBillDriverList: this.subTableData,
                    tEmptyBillDetailList: this.allDataList
                  }).then(res => {
                    console.log(res)
                    this.addLoading = false
                    this.$emit('update:addBillVisible', false)
                    this.$message({
                      message: '添加成功',
                      type: 'success'
                    })
                    // this.$parent.getTime()
                    this.$emit('getTime')
                  }).catch(err => {
                    this.addLoading = false
                    this.$message({
                      message: err.message,
                      type: 'error'
                    })
                  })
                } else if (this.title == '修改提单') {
                  if (this.subTableDataB.length == 0) {
                    this.subTableDataB = this.subTableData
                  } else {
                    this.subTableData.forEach((item) => {
                      this.subTableDataB.push(item)
                    })
                  }
                  console.log(this.subTableDataB, 'this.subTableDataB')
                  this.addLoading = true
                  let obj = {
                    tEmptyBillMaster: {
                      billId: this.addBillForm.billId, // （出库提单id  必填）
                      billNo: this.billNo, // （出库提单号  必填
                      plateNumber: plateNumber, // （出库车牌号 =人车信息 提货车号逗号拼接  必填）
                      driverName: driverName, // （司机姓名 =人车信息 司机姓名逗号拼接  非必填）
                      telephone: telephone, // （司机手机 =人车信息 司机电话逗号拼接 非必填）
                      idNumber: idNumber, // （身份证号 =人车信息 司机身份证逗号拼接 非必填）
                      remark: this.addBillForm.remark, // （出库提单备注 非必填）
                      outBillNo: this.addBillForm.outBillNo, // 客户单号
                      pickupCustomerName: this.addBillForm.pickupCustomerName // 客户单号
                      // carHoldFalg: 0 // 扣车标记 0：不扣，1：扣车 必填）
                    },
                    tEmptyBillDriverList: this.subTableDataB
                  }
                  if (this.emptyBillType == '0') {
                    obj.tEmptyBillDetailList = this.allDataList
                  }
                  JfupEmptyBillJanFa(obj).then(res => {
                    this.addLoading = false
                    this.$emit('update:addBillVisible', false)
                    this.$message({
                      message: '修改成功',
                      type: 'success'
                    })
                    // this.$parent.getTime()
                    this.$emit('getTime')
                    this.subTableDataB = []
                  }).catch(err => {
                    this.addLoading = false
                    this.subTableDataB = []
                    this.$message({
                      message: err.message,
                      type: 'error'
                    })
                  })
                }
              }
            }
          } else {
            this.addLoading = false
          }
        })
      }
    }
  }

</script>

<style scoped lang='less'>
  .xiala {
    .name {
      color: #000;
      line-height: normal;
      margin-top: 6px;
    }

    .addr {
      color: #999;
    }
  }

  /deep/.el-table th.star div::before {
    content: '*' !important;
    color: red !important;
  }

</style>
